import { SessionSorageInstance } from "../SessionStorageService";
import { baseUrl } from "./HelpService";

const PageUrl = baseUrl;

const registerAffiliate = (values: any): Promise<Response | null> => {
  const data = {
    contact_hubspot_id: values['contactHubspotId'],
    user: {
      first_name: values.firstName,
      last_name: values.lastName,
      password: values.password,
      email: values.email,
      phone: values.phoneNumber,
      country_code: `+${values.countryCode}`
    }
  };

  return fetch(PageUrl + "register-affiliate/", {
    method: "POST",
    headers: { "Content-type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response: any) => response.json())
    .then((data: any) => data as Response)
    .catch(() => {
      return null;
    });
};

const loginAffiliate = (values: any): Promise<Response | null> => {
  const data = { email: values.email, password: values.password };
  return fetch(PageUrl + "login-affiliate/", {
    method: "POST",
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify(data)
  })
    .then((response) => response.json())
    .then((data) => data as Response)
    .catch(() => {
      return null;
    });
};

const getAffiliateDashboard = (): Promise<any> => {
  const token = SessionSorageInstance.getToken();

  return fetch(baseUrl + "affiliate_dashboard/summary/", {
    method: "GET",
    headers: {
      'Authorization': token,
      "Content-type": "application/json"
    },
  }).then(async (res) => {
    if (!res.ok) {
      const errorBody = await res.json();
      throw new Error(errorBody?.detail || "Request failed");
    }
    return res.json();
  });
};

const getAffiliateMonthlyBreakdown = (): Promise<any> => {
  const token = SessionSorageInstance.getToken();

  return fetch(baseUrl + "affiliate_dashboard/monthly-breakdown/", {
    method: "GET",
    headers: {
      'Authorization': token,
      "Content-type": "application/json"
    },
  }).then(async (res) => {
    if (!res.ok) {
      const errorBody = await res.json();
      throw new Error(errorBody?.detail || "Request failed");
    }
    return res.json();
  });
};

const AffiliateService = {
  registerAffiliate,
  loginAffiliate,
  getAffiliateDashboard,
  getAffiliateMonthlyBreakdown
};

export default AffiliateService;
